import { lazy } from "react";
import type { RouteObject } from "react-router";
import { SUPER_ADMIN_ROLES } from "@/src/analytics/constants/analytics.constants";
import { ANALYTICS_ROUTES } from "@/src/analytics/constants/analytics-routes.constants";
import { ProtectedRoute } from "@/src/auth/components/protected-route";

const AnalyticsPage = lazy(() => import("@/src/analytics/pages/analytics.page"));

export const analyticsRoutes: RouteObject[] = [
	{
		element: <ProtectedRoute requiredRole={[...SUPER_ADMIN_ROLES]} />,
		children: [{ path: ANALYTICS_ROUTES.analytics, element: <AnalyticsPage /> }],
	},
];
